{
  "links" : {
    "triggerLinksDescription" : "Aktiveringslinks Aktivere Du at lægge links Indre SMS beskeder og Gmail, som Aktivere Du til at spore specifikke kundeaktiviteter og udløser tilfælde baseret Til når der klikkes på Link .",
    "enterName" : "Indtast navn",
    "enterLinkURL" : "Indtast Link URL",
    "save" : "Arkiv",
    "cancel" : "Annuller",
    "delete" : "Slet",
    "aboutToDeleteLink" : "`Du're Om for at slette ${deleteRowName} Link. Slettet Link kan ikke gendannes. Er du sikker på, at du vil Fortsætte?`",
    "noTriggerLinksFound" : "Ingen aktiveringslinks fundet",
    "getStartedByAddingNewTriggerLinks" : "Kom i gang Via at tilføje nye Aktiveringslinks",
    "newTriggerLink" : "Ny udløser Link",
    "searchNoMatch" : "Din Søge matchede ikke noget udløser Link.",
    "link" : "Link",
    "addLink" : "Tilføj Link",
    "linkURL" : "Link URL",
    "name" : "Navn",
    "pleaseEnterNonEmptyLinkName" : "Indtast et ikke-tomt Link",
    "pleaseEnterURL" : "Indtast URL",
    "actions" : "aktiviteter",
    "linkKey" : "Link Vigtig",
    "keyCopied" : "Vigtig Kopieret"
  }
}
